import { useLocation } from 'react-router-dom';
import { Box } from '@mui/material';

import Links from './Links/Links';
import pagesLinks from './PagesLinks';
import AccountMenu from '../AppHeader/components/AccountMenu/AccountMenu';
import { SupportLabel } from '../SupportLabel/SupportLabel';

import './NavigationPane.less';

const NavigationMobilePane = () => {
  const { pathname } = useLocation();

  return (
    <Box className="navigation-mobile-pane">
      <Links links={pagesLinks()} pathName={pathname} />
      <Box className="nav-footer">
        <AccountMenu />
        <SupportLabel />
      </Box>
    </Box>
  );
};

export default NavigationMobilePane;
